























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import { DxDataGrid, DxColumn, DxEditing, DxStateStoring, DxRequiredRule } from 'devextreme-vue/data-grid';

@Component({
  components: {
    cCard,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxStateStoring,
    DxRequiredRule,
  },
})
export default class SellingpriceCompositionCard extends Vue {
  @Prop({ required: true })
  public value!: IArticleSalesPrice[];

  @Prop({ required: true })
  public labourcosts!: IArticleLabourCost[];

  editableValue: IArticleSalesPrice[] = [];

  private tempList: IArticleSalesPrice[] = [];

  mounted() {
    const list = this.$store.getters['catalogs/list']('ProjectTypes');
    this.editableValue = Object.assign(
      [],
      this.value.filter((v) => list.values.indexOf(v.type) !== -1)
    );
  }

  onRowUpdated(e: any) {
    this.$emit('input', this.editableValue);
    e.cancel = false;
  }

  get columns() {
    const self = this;

    return [
      {
        caption: this.$t('objects.articles.ProjectType'),
        calculateCellValue(value: any) {
          if (!value) {
            return '';
          }
          return value.type;
        },
      },
      {
        caption: this.$t('objects.articles.Cost'),
        alignment: 'center',
        columns: [
          {
            caption: 'Arbeid',
            format: {
              type: 'currency',
              precision: 2,
            },
            alignment: 'left',
            calculateCellValue(value: any) {
              if (!value) {
                return 0;
              }

              const labourcost = self.labourcosts.find((o) => o.type === value.type);
              if (!labourcost) {
                return 0;
              }

              return labourcost.cost;
            },
          },
          {
            caption: 'GS',
            format: {
              type: 'currency',
              precision: 2,
            },
            alignment: 'left',
            calculateCellValue(value: any) {
              if (!value) {
                return 0;
              }

              const labourcost = self.labourcosts.find((o) => o.type === value.type);
              if (!labourcost) {
                return value.cost;
              }

              return value.cost - labourcost.cost;
            },
          },
          {
            caption: 'Totaal',
            format: {
              type: 'currency',
              precision: 2,
            },
            alignment: 'left',
            calculateCellValue(value: any) {
              if (!value) {
                return 0;
              }
              return value.cost;
            },
          },
        ],
      },
      {
        caption: this.$t('objects.articles.Margin'),
        dataType: 'number',
        alignment: 'left',
        dataField: 'margin',
        validationRules: [
          {
            type: 'required',
            message: 'Dit veld is verplicht!',
          },
        ],
        allowSorting: false,
      },
      {
        caption: this.$t('objects.articles.Price'),
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
        calculateCellValue(value: any) {
          if (!value) {
            return 0;
          }
          return (value.cost * (100 + value.margin)) / 100;
        },
      },
      {
        caption: this.$t('objects.articles.Profit'),
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
        calculateCellValue(value: any) {
          if (!value) {
            return 0;
          }
          return (value.cost * (100 + value.margin)) / 100 - value.cost;
        },
      },
    ];
  }

  @Watch('value', { deep: true })
  private onValueChanged(value: IArticleSalesPrice[]) {
    this.editableValue = Object.assign([], this.value);
  }
}
